import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _values from "lodash/values";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import TextField from '../components/TextField';
import FormError from '../components/FormError';
import Button from '../../button/Button';
import FinalForm from '../components/finalForm/FinalForm';
import FormRow from '../components/FormRow';
import FinalField from '../components/finalForm/FinalField';
import { submitForm } from './subscriptionFormActions';
import formSubmissionExceptionHandler from '../registration/formSubmissionExceptionHandler';
import { MARKETING_URL } from '../../../../util/urlConstants';
import { SUBSCRIPTION_FIELDS } from '../validation/validationConstants';
import './SubscriptionForm.scss';

var FORM_FIELDS = _values(SUBSCRIPTION_FIELDS);

var SubscriptionForm = function SubscriptionForm() {
  var onSubmit = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return submitForm(formValues);

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", formSubmissionExceptionHandler(_context.t0));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "SubscriptionForm"
  }, /*#__PURE__*/React.createElement(FinalForm, {
    className: "email-form",
    onSubmit: onSubmit,
    fields: FORM_FIELDS
  }, function (formState) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FinalField, {
      field: SUBSCRIPTION_FIELDS.email
    }, function (_ref2) {
      var input = _ref2.input,
          display = _ref2.display;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        placeholder: "yourname@domain.com",
        error: display.error
      }));
    }), /*#__PURE__*/React.createElement(Button, {
      className: "submit",
      type: "submit",
      disabled: formState.submitting
    }, "Subscribe")), /*#__PURE__*/React.createElement(FormError, {
      error: formState.submitError,
      className: "primary-error"
    }));
  }), /*#__PURE__*/React.createElement("p", {
    className: "rss-json-description"
  }, "(subscribe via ", /*#__PURE__*/React.createElement("a", {
    href: "".concat(MARKETING_URL, "/the-work/feed.xml")
  }, "RSS"), " or ", /*#__PURE__*/React.createElement("a", {
    href: "".concat(MARKETING_URL, "/the-work/feed.json")
  }, "JSON"), ")"));
};

SubscriptionForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool,
  error: PropTypes.string
};
export default SubscriptionForm;